import React from 'react';
import { GetBrandedAppName } from '../../../services/BrandingService';

export default function ClassWithNoStudents () {
  return (
    <div className="teacherNoStudentsNotice">
      <div>No students are rostered in this class.</div>
      <div>Ask your admin to finish rostering before using the {GetBrandedAppName()} teacher app.</div>
    </div>
  );
}